<template>
  <div id="Chat">
    <div class="navBars">
      <div>
        <img src="../assets/leftRun.png" @click="backFn">
        <p class="tpname" style="margin: 0 14px">{{ topname ? topname : '+' + topphone }}</p>
        <img src="../assets/infomsgicon3.png">
        <span class="country">{{ topcountryname }}</span>
      </div>
      <div>
        <img src="../assets/fanyi.png" @click="showfanyidialog">
        <img src="../assets/gerenxinxi.png" @click="runxinxi" style="margin-left: 10px;">
      </div>
    </div>
    <div class="chatWrap" ref="getHeight">
      <div class="moreMsgs" v-if="locingtext === '没有更多了'">{{ locingtext }}</div>
        <div class="moreMsgs" @click="getmore" v-else>{{ locingtext }}</div>
        <div :key="index" v-for="(msg, index) in msgList">
          <div v-if="!msg.issend" class="listItem">
            <img v-if="userheadurl" class="userIcon1" :src="userheadurl + '?vs=' + nowTime">
            <span class="xuni1" v-else>{{ topname ? topname.slice(0, 1).toUpperCase() : '' }}</span>
            <div class="textWraps" @click="inMessageFn(msg)" @mouseleave="outMessageFn(msg)">
              <transition name="el-zoom-in-top">
                <section v-show="msg.isTranslat" class="smWraps smWraps1">
                  <!-- <span>撤回</span> -->
                  <span v-show="!msg.TranslatResult" @click="showTranslatFnFn(msg, 'client')">翻译</span>
                  <span v-show="msg.TranslatResult" @click="closeTranslatFn(msg)">关闭翻译</span>
                  <span class="fuzhiButton" v-show="msg.content.Type === 'TEXT'" v-clipboard:copy="copyContent" @click="copyFn(msg.content.Content)">复制</span>
                </section>
              </transition>
              <p class="textmsg" v-show="msg.content.Type === 'TEXT'">{{ msg.content.Content }}</p>
              <p class="trantslate" v-show="msg.TranslatResult && msg.content.Type === 'TEXT' && msg.content.Content">{{ msg.TranslatResult }}</p>
              <div v-show="msg.content.Type === 'IMAGE' && msg.content.url">
                <img style="display: block;" class="contentimg" :src="msg.content.url"/>
                <p class="textmsg" v-show="msg.content.caption">{{ msg.content.caption }}</p>
              </div>
              <div class="content" v-show="msg.content.Type === 'DOCUMENT' && msg.content.url">
                <div class="contentfile">
                  <!-- <i class="el-icon-tickets"></i> -->
                  <van-icon name="comment" @click="updown(msg.content.url, msg.content.filename)" />
                  <span class="filenamenew">{{ msg.content.filename }}</span>
                </div>
              </div>
              <section class="timeWrap timeWrapleft">{{msg.sendtime}}</section>
            </div>
          </div>
          <div v-else class="listItem rightitem">
            <div class="duquWrap">
            </div>
            <div class="textWraps" @click="inMessageFn(msg)" @mouseleave="outMessageFn(msg)">
              <transition name="el-zoom-in-top">
                <section v-show="msg.isTranslat" class="smWraps smWraps2">
                  <!-- <span>撤回</span> -->
                  <span v-show="!msg.TranslatResult" @click="showTranslatFnFn(msg, 'me')">翻译</span>
                  <span v-show="msg.TranslatResult" @click="closeTranslatFn(msg)">关闭翻译</span>
                  <span class="fuzhiButton" v-show="msg.content.Type === 'TEXT'" v-clipboard:copy="copyContent" @click="copyFn(msg.content.Content)">复制</span>
                </section>
              </transition>
              <p class="textmsg" v-show="msg.content.Type === 'TEXT'">{{ msg.content.Content }}</p>
              <p class="trantslate" v-show="msg.TranslatResult && msg.content.Type === 'TEXT' && msg.content.Content">{{ msg.TranslatResult }}</p>
              <div class="imgWrpas" v-show="msg.content.Type === 'IMAGE' && msg.content.url">
                <img class="contentimg" :src="msg.content.url"/>
                <p class="textmsg" v-show="msg.content.caption">{{ msg.content.caption }}</p>
              </div>
              <div class="content" v-show="msg.content.Type === 'DOCUMENT' && msg.content.url">
                <div class="contentfile">
                  <van-icon name="comment" @click="updown(msg.content.url, msg.content.filename)" />
                  <span class="filenamenew">{{ msg.content.filename }}</span>
                </div>
              </div>
              <section class="timeWrap">{{msg.sendtime}}</section>
          </div>
          <img v-if="myhadletx.indexOf('.') !== -1" class="userIcon1 userIcon3" :src="myhadletx + '?vs=' + nowTime">
          <span v-else class="xuni2">{{ downvalue.slice(0, 1).toUpperCase() }}</span>
        </div>
        </div>
    </div>
    <div class="footer">
      <input name="fileInput1" ref="fileInput" class="inputfile" type="file" @change="handleFileChange">
      <input name="fileInput2" ref="wenjianInput" class="wenjianInput" type="file" @change="handleFileChangewenjian">
      <section  ref="emojisBox" class="emojis_box" v-show="isShowEmojisBox">
        <span class="emoji" v-for="(emoji, index) in emojisObj" :key="index" @click="addOneEmoji(emoji)">{{ emoji }}</span>
      </section>
      <section class="fasongWrap" v-show="showfasong">
        <input class="spipt" v-model="translatData" />
        <img src="../assets/delete.png" @click="hidefasongFn">
        <img src="../assets/fasong.png" @click="sendYiWenFn">
      </section>
      <div style="display: flex;align-items: center;">
        <img class="biaoqian" src="../assets/smicon1.png" @click.stop="showdiv('表情')">
        <img src="../assets/smicon2.png" @click.stop="showdiv('图片')">
        <img src="../assets/smicon3.png" @click.stop="showdiv('文件')">
        <img src="../assets/smicon4.png" @click.stop="showfasongFn">
      </div>
      <div class="iptWrap">
        <input :disabled="IsSelfFLAG === false" class="ipt" style="background-color: #F2F4F7 !important;" placeholder="请输入消息内容.."  v-model="textdandu" @keyup.enter="handleKeyCode($event)"/>
        <img src="../assets/fasong.png"  @click="tosure(1)">
      </div>
    </div>
    <van-popup id="fanyidialog" v-model="fanyidialog" get-container="body" >
      <div class="fanyidialogitem1"><span>翻译设置</span><img src="../assets/guanbi.png" @click="hidefanyidialogFn"></div>
      <div class="fanyidialogitem2">
        <p>接收信息翻译为</p>
        <section @click="show1 = true"><span>{{ aa }}</span><img src="../assets/vector.png"></section>
      </div>
      <div class="fanyidialogitem2">
        <p>发出信息翻译为</p>
        <section @click="show22 = true"><span>{{ vv }}</span><img src="../assets/vector.png"></section>
      </div>
      <div class="vanbuttonWrap">
        <van-button size="middle" type="info" @click="WhatsAppCustomerTelephonesSetTranslatesFn">确定</van-button>
        <van-button size="middle" style="margin-left: 8px;" @click="hidefanyidialogFn">取消</van-button>
      </div>
    </van-popup>
    <van-action-sheet v-model="show1" :actions="langAry" @select="onSelect1" />
    <van-action-sheet v-model="show22" :actions="langAry" @select="onSelect2" />
  </div>
</template>
<script>
import { Toast, Dialog } from 'vant-green'
import emojisObj from '../script/emoji'
import ossUpload from '../script/ossUpload'
import axiosNtLoading from 'axios'
import FileSaver from 'file-saver'
import requesObj from '../script/publicUrl'
// import { Toast } from 'vant-green'
import {WhatsAppCustomerTelephonesChatList, WhatsAppSmsSend, WhatsAppCustomerTelephonesSetTranslates} from '../http/api'
export default {
  data () {
    return {
      newtelephone: null,
      IsSelfFLAG: null,
      copyContent: '',
      fileAry: ['xls', 'xlsx', 'et', 'txt', 'pdf', 'ppt', 'pptx', 'csv', 'rar', 'ZIP‌', '7Z', 'TAR', 'GZ', 'GZIP', 'BZ2‌', 'doc', 'docx', 'mp4', 'audio/ogg', 'ogg'],
      count: 0,
      translatData: '',
      tolang: '',
      textdandu: '',
      isShowEmojisBox: false,
      emojisObj: emojisObj.emojis,
      downvalue: '',
      myhadletx: '',
      topname: '',
      topcountryname: '',
      userheadurl: '',
      nowTime: '',
      show1: false,
      show22: false,
      value: '',
      showfasong: false,
      fanyidialog: false,
      aa: '',
      vv: '',
      langAry: [
        {enlabel: 'English', ftlabel: '英語', name: '英语', value: 'en'},
        {enlabel: 'Spanish', ftlabel: '西班牙語', name: '西班牙语', value: 'es'},
        {enlabel: 'Portuguese', ftlabel: '葡萄牙語', name: '葡萄牙语', value: 'pt'},
        {enlabel: 'Hindi', ftlabel: '印地語', name: '印地语', value: 'hi'},
        {enlabel: 'Chinese (Simplified)', ftlabel: '中文（簡體）', name: '中文（简体）', value: 'zh-Hans'},
        {enlabel: 'Chinese (Traditional)', ftlabel: '中文（繁體）', name: '中文（繁体）', value: 'zh-tw'},
        {enlabel: 'Arabic', ftlabel: '阿拉伯語', name: '阿拉伯语', value: 'ar'},
        {enlabel: 'French', ftlabel: '法語', name: '法语', value: 'fr'},
        {enlabel: 'Russian', ftlabel: '俄語', name: '俄语', value: 'ru'},
        {enlabel: 'German', ftlabel: '德語', name: '德语', value: 'de'},
        {enlabel: 'Japanese', ftlabel: '日語', name: '日语', value: 'ja'},
        {enlabel: 'Indonesian', ftlabel: '印尼語', name: '印尼语', value: 'id'},
        {enlabel: 'Turkish', ftlabel: '土耳其語', name: '土耳其语', value: 'tr'},
        {enlabel: 'Italian', ftlabel: '意大利語', name: '意大利语', value: 'it'},
        {enlabel: 'Korean', ftlabel: '韓語', name: '韩语', value: 'ko'},
        {enlabel: 'Thai', ftlabel: '泰語', name: '泰语', value: 'th'},
        {enlabel: 'Vietnamese (Ting Vit)', name: '越南語', label: '越南语', value: 'vi'},
        {enlabel: 'Dutch', ftlabel: '荷蘭語', name: '荷兰语', value: 'nl'},
        {enlabel: 'POLISH', ftlabel: '波蘭語', name: '波兰语', value: 'pl'},
        {enlabel: 'Malay', ftlabel: '馬來語', name: '马来语', value: 'ms'}
      ],
      aad: null,
      wscount: 0,
      locdingBeforeSmsId: 0,
      locingtext: '',
      chatListval: {
        TelephoneId: '',
        CustomerTelephoneId: '',
        BeforeSmsId: 0,
        ChatNum: 8
      },
      msgList: [],
      SmsSendRequest: {
        TelephoneId: this.TelephoneId,
        CustomerTelephoneId: 0,
        MessageId: this.MessageId,
        MessageType: 'text',
        Text: '',
        Link: '',
        Caption: '',
        FileName: '',
        TemplateDetailId: 0,
        VariableArray: {}
      },
      translateData: {
        content: '',
        from: '',
        to: []
      },
      fanyitype1: '',
      fanyitype2: '',
      WhatsAppCustomerTelephonesSetTranslatesData: {
        Id: '',
        Translates: {
          client: '',
          me: ''
        }
      },
      xianshishouji: '',
      sendingdata: {
        SmsTemplateName: '',
        Language: '',
        PageIndex: 1,
        PageSize: 10
      },
      canversdialogVisible: false,
      canverssendingdata: null,
      topphone: ''
    }
  },
  methods: {
    copyFn (flag) {
      this.copyContent = flag
    },
    backFn () {
      this.$router.push({path: '/Home'})
    },
    showfasongFn () {
      if (this.IsSelfFLAG === false) {
        return
      }
      if (!this.tolang) {
        Toast('请先设置翻译语言类型')
        this.fanyidialog = true
        return
      }
      if (!this.textdandu) {
        Toast('请输入内容')
        return
      }
      this.translateFn()
    },
    hidefasongFn () {
      this.showfasong = false
    },
    showfanyidialog () {
      this.fanyidialog = true
      let ass = JSON.parse(localStorage.getItem('client'))
      if (ass) {
        let IninttranslateData = ass
        this.translateData.to[0] = IninttranslateData.client
        this.translateData.from = IninttranslateData.me
        this.WhatsAppCustomerTelephonesSetTranslatesData.Translates.client = IninttranslateData.client
        this.WhatsAppCustomerTelephonesSetTranslatesData.Translates.me = IninttranslateData.me
        for (let a = 0; a < this.langAry.length; a++) {
          if (IninttranslateData.client === this.langAry[a].value) {
            this.aa = this.langAry[a].name
            this.fanyitype1 = this.langAry[a].value
            this.tolang = this.langAry[a].name
          }
          if (IninttranslateData.me === this.langAry[a].value) {
            this.vv = this.langAry[a].name
            this.fanyitype2 = this.langAry[a].value
          }
        }
      }
    },
    runxinxi () {
      let datas = JSON.parse(localStorage.getItem('userMsg'))
      datas = JSON.stringify(datas)
      this.$router.push({path: '/ContactPersonInformation', query: {data: datas}})
    },
    hidefanyidialogFn () {
      this.fanyidialog = false
    },
    onSelect1 (item) {
      this.show1 = false
      this.aa = item.name
      this.fanyitype1 = item.value
    },
    onSelect2 (item) {
      this.show22 = false
      this.vv = item.name
      this.fanyitype2 = item.value
    },
    // websocket
    initWebSocket () {
      console.log('初始化weosocket')
      // const wsuri = 'ws://testappapi.tradepower.net/views/user/WebSocketHandle.ashx?user=' + window.sessionStorage.getItem('token')
      let wsuri
      if (requesObj.requestUrl === 'http://testappapi.tradepower.net') {
        wsuri = 'ws://testappapi.tradepower.net/views/user/WebSocketHandle.ashx?user=' + window.localStorage.getItem('flagMig')
      } else {
        wsuri = 'wss://vipapi.tradepower.net/views/user/WebSocketHandle.ashx?user=' + window.localStorage.getItem('flagMig')
      }
      // wsuri = 'ws://testappapi.tradepower.net/views/user/WebSocketHandle.ashx?user=' + window.localStorage.getItem('flagMig')
      this.websock = new WebSocket(wsuri)
      this.websock.onmessage = this.websocketonmessage
      this.websock.onopen = this.websocketonopen
      this.websock.onerror = this.websocketonerror
      this.websock.onclose = this.websocketclose
    },
    websocketonopen (e) {
      console.log('websoket开启')
      this.websocketsend()
    },
    websocketonerror () { // 连接建立失败重连
      console.log('websoket连接建立失败重连')
      this.wscount += 1
      if (this.wscount < 3) {
        this.initWebSocket()
      }
    },
    websocketonmessage (e) { // 数据接收
      console.log(e)
      let _this = this
      if (e && e.data) {
        _this.tosocketonmessage = JSON.parse(e.data)
        if (_this.tosocketonmessage.type === 14) {
          console.log(_this.newtelephone)
          _this.tomessage = JSON.parse(JSON.parse(e.data).message)
          if (_this.tomessage.from === _this.newtelephone) {
            console.log('相同')
            Dialog.alert({
              message: _this.tomessage.message,
              confirmButtonText: '确定'
            }).then(() => {
              _this.$router.push({path: '/Home'})
              // this.WhatsAppChatTelephonesListFn()
            }).catch(() => {
            })
            // this.$confirm(_this.tomessage.message, this.$t('TiShi'), {
            //   confirmButtonText: this.$t('QueDing'),
            //   // cancelButtonText: this.$t('QuXiao'),
            //   showCancelButton: false,
            //   lockScroll: false,
            //   type: 'warning'
            // }).then(() => {
            //   this.WhatsAppChatTelephonesListFn()
            // })
          }
        }
        if (_this.tosocketonmessage.type === 10) {
          _this.tomessage = JSON.parse(JSON.parse(e.data).message)
          // 当前页面来了消息
          console.log('当前来信息的时候topphone:' + _this.topphone)
          if (_this.topphone === _this.tomessage.to) {
            _this.msgList.push({content: _this.tomessage, issend: false, messageid: '', smsid: _this.locdingBeforeSmsId, sendtime: this.$formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss'), isTranslat: false, TranslatResult: false})
            // this.$nextTick(() => {
            //   const scrollEl = this.$refs.getHeight
            //   scrollEl.scrollTo({ top: scrollEl.scrollHeight, behavior: 'smooth' })
            // })
          }
          // console.log(_this.ipnewtelephone + _this.newtelephone)
          // if (_this.tomessage.from === _this.ipnewtelephone + _this.newtelephone) {
          //   let dontHasItem = false
          //   if (this.telephonevalList.length === 0) {
          //     this.WhatsAppCustomerTelephonesListFn('has')
          //   } else {
          //     for (let a = 0; a < this.telephonevalList.length; a++) {
          //       if (this.telephonevalList[a].telephone !== _this.tomessage.to) {
          //         dontHasItem = true
          //         break
          //       }
          //     }
          //     console.log(dontHasItem)
          //     if (dontHasItem === true) {
          //       this.WhatsAppCustomerTelephonesListFn('has')
          //     }
          //   }
          // }
          // // 除了我别的人员来了消息
          // _this.telephonevalList.forEach(res => {
          //   if (res.telephone === _this.tomessage.to) {
          //     if (_this.topphone === res.telephone && _this.tomessage.from === _this.ipnewtelephone + _this.newtelephone) {
          //       // 发送的消息改变左边列表最后一条消息内容显示
          //       // res.content = _this.tomessage.Content
          //       res.noreadcount = 0
          //     } else if (_this.topphone !== res.telephone && _this.tomessage.from === _this.ipnewtelephone + _this.newtelephone) {
          //       // 发送的消息改变左边列表最后一条消息内容显示
          //       // res.content = _this.tomessage.Content
          //       res.noreadcount += 1
          //     }
          //     if (_this.tomessage.Type === 'TEMPLATE') {
          //       res.content = '模板'
          //     } else if (_this.tomessage.Type === 'IMAGE') {
          //       res.content = '图片'
          //     } else if (_this.tomessage.Type === 'DOCUMENT') {
          //       res.content = '文件'
          //     } else if (_this.tomessage.Type === 'AUDIO') {
          //       res.content = '音频'
          //     } else if (_this.tomessage.Type === 'VIDEO') {
          //       res.content = '视频'
          //     } else {
          //       res.content = _this.tomessage.Content
          //     }
          //   }
          // })
          // // 解决点击的页面后端总数的问题
          // if (_this.tomessage.from === _this.ipnewtelephone + _this.newtelephone && _this.topphone === _this.tomessage.to) {
          //   // const dataval = {
          //   //   TelephoneId: _this.chatListval.TelephoneId,
          //   //   CustomerTelephoneId: _this.chatListval.CustomerTelephoneId
          //   // }
          //   // WhatsAppCustomerTelephonesChatReaded(dataval, 'has').then(response => {
          //   //   if (response.code === 200 && response.result) {}
          //   // })
          // }
          // // 账号总数也+1条
          // this.downvalList.forEach(res => {
          //   // 如果对应的来了消息 给账号加一console.log(_this.newtelephone, _this.tomessage.from.slice(2),res.telephone,this.topphone,_this.tomessage.to)
          //   // 当前的  _this.newtelephone
          //   //  来的   _this.tomessage.from.slice(2)
          //   // 循环的  res.telephone
          //   // 1 来的和当前  不一样 肯定 +1
          //   // 2 来的和当前的 一样   a  没选择聊天 +1   b  选择了聊天且聊天不等于to +1
          //   if (_this.ipnewtelephone + _this.newtelephone !== _this.tomessage.from && _this.tomessage.from === res.areacode + res.telephone) {
          //     res.NoReadCount = res.NoReadCount + 1
          //   } else if (_this.ipnewtelephone + _this.newtelephone === _this.tomessage.from && res.areacode + res.telephone === _this.tomessage.from && _this.topphone !== _this.tomessage.to) {
          //     res.NoReadCount = res.NoReadCount + 1
          //   }
          // })
          // if (this.topphone) {
          //   console.log(this.topphone)
          // }
          setTimeout(function () {
            _this.$nextTick(() => {
              const scrollEl = _this.$refs.getHeight
              scrollEl.scrollTo({ top: scrollEl.scrollHeight, behavior: 'smooth' })
            })
          }, 500)
        }
      }
    },
    websocketsend (data) { // 数据发送
      let _this = this
      this.textlinkdk = ''
      _this.aad = setInterval(function () {
        _this.websock.send('前端发送心跳检测' + _this.count)
        _this.count += 1
      }, 60000)
    },
    websocketclose (e) { // 关闭
      // if (this.wscount < 3) {
      //   this.websock.close()
      //   this.initWebSocket()
      // } else {
      //   return
      // }
      // console.log('关闭soket')
    },
    WhatsAppCustomerTelephonesChatListFn () {
      let _this = this
      WhatsAppCustomerTelephonesChatList(this.chatListval).then(response => {
        if (response.code === 200 && response.result) {
          response.result.forEach((element, index) => {
            element.isTranslat = false
            element.TranslatResult = ''
            element.content = JSON.parse(element.content)
            if (element.content.hasOwnProperty('Type')) element.content.Type = element.content.Type.toUpperCase()
            this.chatListval.BeforeSmsId = element.content.smsid
            // 当点击了列表 当前可读数量为0
            if (index + 1 === response.result.length) {
              this.locdingBeforeSmsId = element.smsid
            }
            if (index >= 7) {
              this.locingtext = '加载更多'
            } else {
              this.locingtext = '没有更多了'
            }
            // 变量显示
            element.variableAry = []
            if (element.content.headVariable) {
              let kong = {}
              kong.Name = element.content.headVariable.Code
              kong.zw = element.content.headVariable.Name
              kong.Value = element.content.headVariable.Example
              element.content.headContent = element.content.headContent.replace('<span title =\"$(' + kong.Name + ')\" class=\'BianLiang\'>' + kong.zw + '</span>', '<span title="${' + kong.Name + '}" class="BianLiang">' + element.content[kong.Name] + '</span>') // eslint-disable-line
            }
            if (element.content.bodyVariable) {
              for (let a = 0; a < element.content.bodyVariable.length; a++) {
                let kong = {}
                kong.Name = element.content.bodyVariable[a].Code
                kong.zw = element.content.bodyVariable[a].Name
                kong.Value = element.content.bodyVariable[a].Example
                let aa = this.eval('/\\$\\(' + kong.Name + '\\)/g')
                element.content.mainBody = element.content.mainBody.replace(element.content.mainBody.match(aa), '<span title="${' + kong.Name + '}" class="BianLiang">' + element.content[kong.Name] + '</span>')
              }
            }
          })
          this.msgList = response.result.reverse()
          this.show2 = true
          setTimeout(function () {
            _this.$nextTick(() => {
              const scrollEl = _this.$refs.getHeight
              scrollEl.scrollTo({ top: scrollEl.scrollHeight, behavior: 'smooth' })
            })
          }, 500)
        } else {
          this.msgList = []
          this.show2 = true
        }
      })
    },
    getmore () {
      let _this = this
      this.chatListval.BeforeSmsId = this.locdingBeforeSmsId
      this.locingtext = '加载中'
      WhatsAppCustomerTelephonesChatList(this.chatListval).then(response => {
        if (response.code === 200 && response.result) {
          response.result.forEach((element, index) => {
            element.isTranslat = false
            element.TranslatResult = false
            element.content = JSON.parse(element.content)
            if (element.content.hasOwnProperty('Type')) element.content.Type = element.content.Type.toUpperCase()
            this.chatListval.BeforeSmsId = element.content.smsid
            if (index + 1 === response.result.length) {
              this.locdingBeforeSmsId = element.smsid
            }
            this.msgList.unshift(element)
            if (index >= 7) {
              this.locingtext = '加载更多'
            } else {
              this.locingtext = '没有更多了'
            }
            // 变量显示
            element.variableAry = []
            if (element.content.headVariable) {
              let kong = {}
              kong.Name = element.content.headVariable.Code
              kong.zw = element.content.headVariable.Name
              kong.Value = element.content.headVariable.Example
              element.content.headContent = element.content.headContent.replace('<span title =\"$(' + kong.Name + ')\" class=\'BianLiang\'>' + kong.zw + '</span>', '<span title="${' + kong.Name + '}" class="BianLiang">' + element.content[kong.Name] + '</span>') // eslint-disable-line
            }
            if (element.content.bodyVariable) {
              for (let a = 0; a < element.content.bodyVariable.length; a++) {
                let kong = {}
                kong.Name = element.content.bodyVariable[a].Code
                kong.zw = element.content.bodyVariable[a].Name
                kong.Value = element.content.bodyVariable[a].Example
                let aa = this.eval('/\\$\\(' + kong.Name + '\\)/g')
                element.content.mainBody = element.content.mainBody.replace(element.content.mainBody.match(aa), '<span title="${' + kong.Name + '}" class="BianLiang">' + element.content[kong.Name] + '</span>')
              }
            }
          })
        } else {
          this.locingtext = '没有更多了'
        }
        setTimeout(function () {
          _this.$nextTick(() => {
            const scrollEl = _this.$refs.getHeight
            scrollEl.scrollTo({ top: 0, behavior: 'smooth' })
          })
        }, 500)
      })
    },
    addOneEmoji (emoji) {
      this.textdandu = this.textdandu + emoji
      // this.isShowEmojisBox = false
    },
    // 发送
    tosure (val) {
      const _this = this
      if (val === 1) { // 输入框有内容的时候 （包含表情和文字）
        if (!_this.textdandu) {
          Toast('消息内容不能为空')
          // this.$message.error(this.$t('XiaoXiNeiRongBuNengWeiKong'))
          return false
        }
        _this.SmsSendRequest.Text = _this.textdandu
        _this.SmsSendRequest.MessageType = 'text'
        _this.SmsSendRequest.FileName = ''
        _this.SmsSendRequest.Link = ''
      }
      if (val === 2) { // 发送模板
        _this.SmsSendRequest.MessageType = ''
        _this.SmsSendRequest.FileName = ''
        _this.SmsSendRequest.Link = ''
        _this.SmsSendRequest.MessageId = ''
        _this.SmsSendRequest.Caption = ''
        _this.SmsSendRequest.TemplateDetailId = _this.canverssendingdata.Id
        const dataval = {}
        this.addvausdd.forEach(res => {
          dataval[res.name] = res.value
        })
        _this.SmsSendRequest.VariableArray = dataval
      } else {
        _this.SmsSendRequest.TemplateDetailId = 0
        _this.SmsSendRequest.VariableArray = {}
      }
      var data
      if (val === 2) { // 发送模板
        _this.canverssendingdata.TemplateContent.Type = _this.canverssendingdata.TemplateContent.Type.toUpperCase()
        _this.canverssendingdata.TemplateContent.mainBody = _this.mainBody
        data = {
          content: _this.canverssendingdata.TemplateContent,
          issend: true,
          sendtime: this.$formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss'),
          messageid: '',
          smsid: '',
          topphone: _this.topphone,
          newyes: ''
        }
      } else {
        // this.SmsSendRequest.CustomerTelephoneId = this.CustomerTelephoneId
        _this.SmsSendRequest.MessageId = this.locdingBeforeSmsId
        data = {
          isTranslat: false,
          TranslatResult: false,
          content: {
            Type: _this.SmsSendRequest.MessageType.toUpperCase(),
            Content: _this.SmsSendRequest.Text,
            url: _this.SmsSendRequest.Link,
            caption: '',
            filename: _this.SmsSendRequest.FileName
          },
          issend: true,
          messageid: '',
          smsid: '',
          sendtime: this.$formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss'),
          topphone: _this.topphone,
          newyes: ''
        }
      }
      WhatsAppSmsSend(_this.SmsSendRequest, 'has').then(response => {
        if (response.code === 200) {
          data.newyes = true
          data.isTranslat = false
          data.TranslatResult = false
          // data.headurl = this.getuserheadurl
          if (_this.SmsSendRequest.Text) _this.textdandu = ''
          this.translateData.content = ''
          this.fanyiFlag = false
          // if (val === 2) {
          // this.sendingdialogVisible = false
          // }
        } else {
          _this.textdandu = ''
          data.newyes = false
        }
      })
      if (data.content.Type === 'TEMPLATE') {
        data.content.Type = data.content.Type.toUpperCase()
        // 变量显示
        data.variableAry = []
        if (data.content.headVariable) {
          data.content.headContent = data.content.headContent.replace('<span title = +\"$(' + data.content.headVariable.Code + ')\" class=\'BianLiang\'>' + data.content.headVariable.Name + '</span>', '<span title="${' + data.content.headVariable.Code + '}" class="BianLiang">' + data.content[data.content.headVariable.Code] + '</span>') // eslint-disable-line
        }
        if (data.content.bodyVariable) {
          for (let a = 0; a < data.content.bodyVariable.length; a++) {
            let aa = this.eval('/\\$\\(' + data.content.bodyVariable[a].Code + '\\)/g')
            data.content.mainBody = data.content.mainBody.replace(data.content.mainBody.match(aa), '<span title="${' + data.content.bodyVariable[a].Code + '}" class="BianLiang">' + data.content[data.content.bodyVariable[a].Code] + '</span>')
          }
        }
      }
      console.log(data)
      this.msgList.push(data)
      // 发完消息之后滚动条直接滚动到最下面
      setTimeout(function () {
        _this.$nextTick(() => {
          const scrollEl = _this.$refs.getHeight
          scrollEl.scrollTo({ top: scrollEl.scrollHeight, behavior: 'smooth' })
        })
      }, 500)
    },
    // 添加表情
    showdiv (text) {
      if (this.IsSelfFLAG === false) {
        return
      }
      if (text === '表情') {
        this.isShowEmojisBox = true
      } else if (text === '图片') {
        this.SmsSendRequest.MessageType = 'image'
        this.SmsSendRequest.Text = ''
        this.$refs.fileInput.click()
        // ossUpload(1, 1).then(res => {
        //   this.SmsSendRequest.Link = res.filename
        //   this.SmsSendRequest.Link = res.url
        //   this.tosure()
        // })
      } else if (text === '音频') {
        this.SmsSendRequest.MessageType = 'video'
        this.SmsSendRequest.Text = ''
        ossUpload(2, 2).then(res => {
          this.SmsSendRequest.FileName = res.filename
          this.SmsSendRequest.Link = res.url
          this.tosure()
        })
      } else if (text === '文件') {
        this.SmsSendRequest.MessageType = 'document'
        this.SmsSendRequest.Text = ''
        this.sendingdata.SmsTemplateName = ''
        this.sendingdata.Language = ''
        this.$refs.wenjianInput.click()
      } else if (text === '翻译') {
        console.log(this.tolang)
        // this.fanyiFlag = true
        if (!this.tolang) {
          Toast('请先设置翻译语言类型')
          return false
        }
        if (!this.textdandu) {
          Toast('请先输入内容')
          return false
        }
        this.translateFn()
      }
    },
    // 回车发送
    handleKeyCode (event) {
      if (event.keyCode === 13) {
        if (!event.metaKey) {
          event.preventDefault()
          this.tosure(1)
        } else {
          this.textdandu = this.textdandu + '\n'
        }
      }
    },
    translateFn () {
      console.log()
      this.translateData.content = this.textdandu
      this.translateData.to[0] = this.WhatsAppCustomerTelephonesSetTranslatesData.Translates.client
      this.translateData.from = ''
      this.fyFn()
    },
    fyFn () {
      let _this = this
      axiosNtLoading({
        headers: {
          'Authorization-Language': window.localStorage.getItem('selectLang') || 'zh-Hans',
          'Authorization-Token': window.localStorage.getItem('flagMig'),
          'Authorization-ValidateType': 'web',
          'Authorization-RefSite': window.document.domain
        },
        method: 'post',
        url: 'https://vipapi.tradepower.net/v1/user/translate',
        data: this.translateData
      }).then(function (response) {
        console.log(response)
        if (response.data.code === 200) {
          _this.showfasong = true
          _this.translatData = response.data.result[0]
        }
      })
    },
    sendYiWenFn () {
      if (this.IsSelfFLAG === false) {
        return
      }
      let _this = this
      if (!_this.translatData) {
        Toast('内容不能为空')
        return false
      }
      // _this.SmsSendRequest.CustomerTelephoneId = this.CustomerTelephoneId
      _this.SmsSendRequest.MessageId = this.locdingBeforeSmsId
      _this.SmsSendRequest.Text = _this.translatData
      _this.SmsSendRequest.MessageType = 'text'
      _this.SmsSendRequest.FileName = ''
      _this.SmsSendRequest.Link = ''
      var data = {
        content: {
          Type: _this.SmsSendRequest.MessageType.toUpperCase(),
          Content: _this.SmsSendRequest.Text,
          url: _this.SmsSendRequest.Link,
          caption: '',
          filename: _this.SmsSendRequest.FileName
        },
        isTranslat: false,
        TranslatResult: false,
        issend: true,
        messageid: '',
        smsid: '',
        sendtime: this.$formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss'),
        topphone: _this.topphone,
        newyes: ''
      }
      WhatsAppSmsSend(_this.SmsSendRequest, 'has').then(response => {
        if (response.code === 200) {
          data.newyes = true
          if (_this.SmsSendRequest.Text) _this.textdandu = ''
          this.translateData.content = ''
          this.fanyiFlag = false
          // if (val === 2) {
          //   this.sendingdialogVisible = false
          // }
        } else {
          _this.textdandu = ''
          data.newyes = false
        }
      })
      this.msgList.push(data)
      this.translatData = ''
      this.showfasong = false
      // 发完消息之后滚动条直接滚动到最下面
      this.$nextTick(() => {
        const scrollEl = _this.$refs.getHeight
        scrollEl.scrollTo({ top: scrollEl.scrollHeight, behavior: 'smooth' })
      })
    },
    WhatsAppCustomerTelephonesSetTranslatesFn () {
      if (!this.fanyitype1 || !this.fanyitype2) {
        Toast('请选中需要翻译的内容')
        return
      }
      this.WhatsAppCustomerTelephonesSetTranslatesData.Translates.client = this.fanyitype1
      this.WhatsAppCustomerTelephonesSetTranslatesData.Translates.me = this.fanyitype2
      this.WhatsAppCustomerTelephonesSetTranslatesData.Translates = JSON.stringify(this.WhatsAppCustomerTelephonesSetTranslatesData.Translates)
      WhatsAppCustomerTelephonesSetTranslates(this.WhatsAppCustomerTelephonesSetTranslatesData).then(response => {
        if (response.code === 200) {
          this.translateData.to[0] = this.fanyitype1
          this.translateData.from = this.fanyitype2
          this.tolang = this.fanyitype1
          // this.fanyitype1 = ''
          // this.fanyitype2 = ''
          this.fanyidialog = false
          this.WhatsAppCustomerTelephonesSetTranslatesData.Translates = JSON.parse(this.WhatsAppCustomerTelephonesSetTranslatesData.Translates)
          let obj = {
            client: this.fanyitype1,
            me: this.fanyitype2
          }
          localStorage.setItem('client', JSON.stringify(obj))
        }
      })
    },
    inMessageFn (row) {
      console.log(row)
      row.isTranslat = false
      if (row.content.Type === 'TEXT' && row.content.Content) {
        row.isTranslat = true
      }
    },
    outMessageFn (row) {
      row.isTranslat = false
    },
    closeTranslatFn (row) {
      row.TranslatResult = ''
    },
    showTranslatFnFn (row, type) {
      if (!this.WhatsAppCustomerTelephonesSetTranslatesData.Translates.client || !this.WhatsAppCustomerTelephonesSetTranslatesData.Translates.me) {
        this.fanyiDialog = true
        Toast('请先设置语言翻译')
        return
      }
      this.translateData.content = row.content.Content
      this.translateData.to = []
      if (type === 'client') {
        this.translateData.to[0] = this.WhatsAppCustomerTelephonesSetTranslatesData.Translates.me
      } else {
        this.translateData.to[0] = this.WhatsAppCustomerTelephonesSetTranslatesData.Translates.me
      }
      this.translateData.from = ''
      axiosNtLoading({
        headers: {
          'Authorization-Language': 'zh-Hans',
          'Authorization-Token': window.localStorage.getItem('flagMig'),
          'Authorization-ValidateType': 'web',
          'Authorization-RefSite': window.document.domain
        },
        method: 'post',
        url: 'https://vipapi.tradepower.net/v1/user/translate',
        data: this.translateData
      }).then(function (response) {
        if (response.data.code === 200) {
          row.TranslatResult = response.data.result[0]
        }
      })
    },
    handleFileChange (event) {
      const file = event.target.files[0] // 获取选择的文件
      console.log(file)
      if (file) {
        if (file.type !== 'image/png' && file.type !== 'image/jpg' && file.type !== 'image/jpeg' && file.type !== 'image/bmp' && file.type !== 'image/gif') {
          Toast('只能上传图片')
          return
        }
        // if (file.size > 10240) {
        //   Toast('图片大小不能超过10KB')
        //   return
        // }
        this.SmsSendRequest.MessageType = 'image'
        this.SmsSendRequest.Text = ''
        // this.tosure()
        this.uploadImage(file)
        // 处理文件，例如预览或上传
        // this.uploadImage(file);
      }
    },
    uploadImage (file) {
      // 实现上传逻辑，例如使用FormData发送到服务器
      const formData = new FormData()
      formData.append('image', file)
      // 使用axios或其他HTTP库发送formData到服务器
      // axios.post('/upload', formData).then(response => { /* 处理响应 */ });
      this.UploadFn(formData)
    },
    UploadFn (formData) {
      let _this = this
      axiosNtLoading({
        headers: {
          'Authorization-Language': window.localStorage.getItem('selectLang') || 'zh-Hans',
          'Authorization-Token': window.localStorage.getItem('flagMig'),
          'Authorization-ValidateType': 'web',
          'Authorization-RefSite': window.document.domain
        },
        method: 'post',
        url: requesObj.requestUrl + '/V1/User/file/Upload',
        data: formData
      }).then(function (response) {
        if (response.data.code === 200) {
          _this.SmsSendRequest.Link = response.data.result[0]
          _this.SmsSendRequest.FileName = formData.FileName
          _this.tosure()
        }
        _this.$refs.fileInput.value = ''
        _this.$refs.wenjianInput.value = ''
      })
    },
    handleFileChangewenjian (event) {
      const file = event.target.files[0] // 获取选择的文件
      let name = file.name.substring(file.name.indexOf('.') + 1)
      console.log(file)
      if (this.fileAry.indexOf(name) === -1) {
        Toast('文件只支持xls, xlsx, et, txt, pdf, doc, docx, ppt, pptx, csv, rar, ZIP‌, 7Z, TAR, GZ, GZIP, BZ2‌')
        return
        // fileAry
      }
      this.uploadTemplate(file, name)
    },
    uploadTemplate (file, type) {
      // 实现上传逻辑，例如使用FormData发送到服务器
      const formData = new FormData()
      formData.append(type, file)
      formData.FileName = file.name
      // 使用axios或其他HTTP库发送formData到服务器
      // axios.post('/upload', formData).then(response => { /* 处理响应 */ });
      this.UploadFn(formData)
    },
    updown (url, filename) {
      FileSaver.saveAs(url, filename)
    }
  },
  mounted () {
    document.addEventListener('click', (e) => {
      console.log(e)
      if (e.target.className !== 'emoji' && e.target.className !== 'emojis_box') {
        this.isShowEmojisBox = false
      }
    })
    this.IsSelfFLAG = localStorage.getItem('IsSelf')
    this.newtelephone = localStorage.getItem('newtelephone')
    console.log(this.newtelephone)
    let datas = JSON.parse(localStorage.getItem('userMsg'))
    if (datas) {
      this.initWebSocket()
    }
    this.nowTime = new Date().getTime()
    let getTelephoneId = localStorage.getItem('TelephoneId')
    this.myhadletx = localStorage.getItem('myhadletx')
    if (this.myhadletx.indexOf('.') === -1) {
      this.downvalue = this.myhadletx
    }
    // this.myhadletx = getmyhadletx
    this.topname = datas.name
    this.topcountryname = datas.countryname
    this.userheadurl = datas.headurl
    this.chatListval.CustomerTelephoneId = datas.id
    this.SmsSendRequest.CustomerTelephoneId = datas.id
    this.WhatsAppCustomerTelephonesSetTranslatesData.Id = datas.id
    this.chatListval.BeforeSmsId = 0
    this.chatListval.TelephoneId = getTelephoneId
    this.SmsSendRequest.TelephoneId = getTelephoneId
    this.xianshishouji = datas.mobileareacode + datas.mobile
    this.topphone = datas.telephone
    let ass = JSON.parse(localStorage.getItem('client'))
    if (ass) {
      let IninttranslateData = ass
      this.translateData.to[0] = IninttranslateData.client
      this.translateData.from = IninttranslateData.me
      this.WhatsAppCustomerTelephonesSetTranslatesData.Translates.client = IninttranslateData.client
      this.WhatsAppCustomerTelephonesSetTranslatesData.Translates.me = IninttranslateData.me
      // console.log(IninttranslateData)
      for (let a = 0; a < this.langAry.length; a++) {
        if (IninttranslateData.client === this.langAry[a].value) {
          this.aa = this.langAry[a].name
          this.fanyitype1 = this.langAry[a].value
          this.tolang = this.langAry[a].name
        }
        if (IninttranslateData.me === this.langAry[a].value) {
          this.vv = this.langAry[a].name
          this.fanyitype2 = this.langAry[a].value
        }
      }
    }
    this.WhatsAppCustomerTelephonesChatListFn()
  },
  beforeDestroy () {
    if (this.websock) {
      console.log('beforeDestroy前退出socket')
      clearInterval(this.aad)
      this.websock.close()
    }
  }
}
</script>
<style scoped>
#Chat{height: 100%;}
.navBars{color: #303133;font-weight: bold;font-size: 16px;padding: 14px 10px;display: flex;align-items: center;justify-content: space-between;border-bottom: 1px solid #E1E5ED;}
.country{color: #919499;font-weight: normal;font-size: 14px;}
.navBars>div{display: flex;align-items: center;}
.navBars>div>span{margin: 0 8px;}
.navBars img{cursor: pointer;}
.chatWrap{height: calc(100% - 158px);overflow-y: auto;background: url('https://static.cnwte.net/site/bangsmg.png') 0 0 no-repeat; background-size: cover;width: 94%;margin: 0 auto;padding: 0 3%;}
/* .chatWrap>div{overflow: hidden;} */
.footer{height: 100px;padding-top: 4px;position: relative;}
.footer>div{padding: 10px 0;}
.footer>div>img{margin-left: 8px;}
.ipt{width: 94%;background-color: #F2F4F7;border-radius: 4px;margin: 0 auto 0;height: 40px;line-height: 40px;border: none;display: block;padding: 0 4px;color: #303133;}
.ipt div{background-color: #F2F4F7 !important;}
.fasongWrap{width: 100%;display: flex;align-items: center;padding: 12px 0;border-bottom: 1px solid #ccc;position: absolute;top: -49px;background-color: #fff;}
.fasongWrap>img{margin-left: 16px;}
.spipt{border: none;width: 70%;padding: 0 4px;text-indent: 1em;}
#fanyidialog{width: 88%;padding: 0 4%;border-radius: 8px;font-size: 14px;}
.fanyidialogitem1{display: flex;justify-content: space-between;align-items: center;padding: 8px 0;color: #333;font-weight: bold;font-size: 16px;}
.fanyidialogitem2>p{color: #919499;margin: 14px 0 6px 0;}
.fanyidialogitem2>section{padding: 8px 14px;background-color: #F2F4F7;border-radius: 4px;display: flex;align-items: center;justify-content: space-between;height: 40px;}
.vanbuttonWrap{margin: 20px auto 20px;display: flex;justify-content: center;}
.vanbuttonWrap>button{flex: 1;}
.moreMsgs {cursor: pointer;text-align: center;padding-top: 4px;}
.listItem{display: flex;font-size: 14px;margin-top: 20px;margin-bottom:25px;cursor:pointer}
.userIcon1,.userIcon2{width: 32px;height: 32px;border-radius: 50%;}
.userIcon1{margin-right: 8px;}
.userIcon3{margin-right: 0 !important;margin-left: 8px;}
.xuni1{margin-right: 8px;}
.xuni2{margin-left: 8px;}
.xuni1,.xuni2{width: 32px;height: 32px;line-height: 32px;text-align: center;border-radius: 50%;background-color: #3662EC;color: #fff;}
.userIcon2{margin-left: 8px;}
.duquWrap{margin-right: 8px;display: flex;flex-direction: column;align-self: center}
.duquWrap>img{width: 16px;height: 16px;}
.textWraps{max-width: 80%;position:relative}
.listItem>.textWraps>p{padding: 12px;border-radius: 4px;display: block;background-color: #fff;line-height: 20px;word-wrap: break-word;}
.rightitem>.textWraps>p{background-color: #E1FFCD !important;display: block;word-wrap: break-word;}
.rightitem{justify-content: end;}
.shanchuhuihuaWrap>p:nth-child(2){border-top: 1px solid #ccc;}
.trantslate{border-top: 1px solid #CFD2D9;}
.timeWrap{margin-top:6px;text-align:right}
.smWraps{background-color: #000; opacity: .8;margin-bottom: 4px;border-radius: 4px;padding: 8px 0;color: #fff;width: auto !important;text-align: center;font-size: 12px;}
.inputfile,.wenjianInput{display: none;}
.smWraps1{max-width: 60PX;font-size: 10px;}
.tpname{max-width: 130px;
    /* 设置宽度 */
    overflow: hidden;
    /* 超出隐藏 */
    text-overflow: ellipsis;
    /* 显示省略号 */
    display: -webkit-box;
    /*将对象作为弹性伸缩盒子模型显示*/
    -webkit-line-clamp: 1;
    /* 控制显示的行数 */
    -webkit-box-orient: vertical;}
.emojis_box{position: absolute;left: 15px;top: -292px;width: 92%;height: 285px;border-radius: 5px;display: flex;flex-direction: row;flex-wrap: wrap;
  justify-content: space-between;align-items: center;background: #fff;padding: 10px 0;box-shadow: 0px 0px 4px 0px #000;overflow-y: auto;
}
.emoji{font-size: 16px;display: inline-block;width: 30px;height: 30px;text-align: center;line-height: 30px;cursor: pointer;transition: all 0.3s ease;
  &:hover {
      transform: scale(1.2);
  }
}
.imgWrpas{text-align: right;}
.contentimg{max-width: 90%;}
.content{padding: 12px;border-radius: 4px;background-color: #E1FFCD !important;}
.iptWrap{display: flex;align-items: center;margin: 0 auto;padding: 10px 3% !important;}
.fuzhiButton{margin-left: 10px;}
</style>



// WEBPACK FOOTER //
// src/view/Chat.vue